import {useAppSelector} from "../../store/hooks";
import {ViewType} from "../../view_type/ViewType";
import {useOfferPageAmplitudeItemListTrackingContext} from "../tracking/OfferPageAmplitudeItemListTrackingContext";

export const useOfferPagePromotionTrackingIds = () => {
    const {itemListContext, isResolved} = useOfferPageAmplitudeItemListTrackingContext();
    const viewType = useAppSelector((state) => state.viewType.current);
    const property = useAppSelector((state) => state.property.property);
    const offer = useAppSelector((state) => state.offerDetail.offer);

    if (!isResolved) {
        return null;
    }

    if (viewType === ViewType.PROPERTY && property) {
        return {
            offerId: property.offer.id,
            propertyId: property.id,
            itemListId: itemListContext?.itemListId
        };
    }

    if (offer) {
        return {
            offerId: offer.id,
            propertyId: null as number | null,
            itemListId: itemListContext?.itemListId
        };
    }

    if (property) {
        return {
            offerId: property.offer.id,
            propertyId: property.id,
            itemListId: itemListContext?.itemListId
        };
    }

    return null;
};
import {useAppSelector} from "../../store/hooks";
import {ViewType} from "../../view_type/ViewType";
import {useOfferPageAmplitudeItemListTrackingContext} from "../tracking/OfferPageAmplitudeItemListTrackingContext";

export const useOfferPagePromotionTrackingIds = () => {
    const {itemListContext, isResolved} = useOfferPageAmplitudeItemListTrackingContext();
    const viewType = useAppSelector((state) => state.viewType.current);
    const property = useAppSelector((state) => state.property.property);
    const offer = useAppSelector((state) => state.offerDetail.offer);

    if (!isResolved) {
        return null;
    }

    if (viewType === ViewType.PROPERTY && property) {
        return {
            offerId: property.offer.id,
            propertyId: property.id,
            itemListId: itemListContext?.itemListId
        };
    }

    if (offer) {
        return {
            offerId: offer.id,
            propertyId: null as number | null,
            itemListId: itemListContext?.itemListId
        };
    }

    if (property) {
        return {
            offerId: property.offer.id,
            propertyId: property.id,
            itemListId: itemListContext?.itemListId
        };
    }

    return null;
};
